import React from "react";
import { useTranslation } from "react-i18next";
import Visibility from "../utils/Visibility";
import BranchInfo from "./BranchInfo";
import SocialMedia from "./SocialMedia";
import BranchModel from "../../Models/BranchModel";
import SocialMeidaModel from "../../Models/SocialMeidaModel";
import { SheetContent } from "../ui/sheet";
import { indexStore } from "../../store/indexStore";
const Details = (props: {
  branch: BranchModel;
  social: SocialMeidaModel[];
}) => {
  const { t } = useTranslation();

  // استخدام البيانات من props أولاً، وإذا لم تكن موجودة نستخدم store
  const { social: socialFromStore, branch: branchFromStore } = indexStore();
  const branch = props.branch || branchFromStore;
  const social = props.social || socialFromStore;

  return (
    <SheetContent
      side={"bottom"}
      className="flex flex-col p-0 max-h-[70vh] overflow-hidden z-50"
    >
      {/* Header */}
      <div className="px-6 pt-6 pb-4 border-b border-border bg-gradient-to-r from-primary/5 via-primary/3 to-primary/5">
        <h2 className="text-2xl font-bold text-foreground">{t("gloabl.info")}</h2>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto px-6 py-4 space-y-6">
        {branch && Object.keys(branch).length > 0 && (
          <BranchInfo branch={branch} />
        )}
        <Visibility visible={social && social.length !== 0}>
          <SocialMedia social={social} />
        </Visibility>
      </div>
    </SheetContent>
  );
};
export default Details;
